import { inject, Injectable } from '@angular/core';
import {
  collection,
  collectionSnapshots,
  Firestore,
} from '@angular/fire/firestore';
import { BaseTag, TagCategory, TAG_CATEGORIES } from '@sleipai/sleip-models';
import { catchError, forkJoin, map, Observable, of, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private firestore = inject(Firestore);

  private readonly categories: readonly TagCategory[] = TAG_CATEGORIES;

  getTags(): Observable<{ [category: string]: { [id: string]: BaseTag } }> {
    const requests = this.categories.map((category: TagCategory) => {
      const colRef = collection(
        this.firestore,
        `tags/${category}/${category}-tags`
      );
      return collectionSnapshots(colRef).pipe(
        take(1),
        map((snapshots) => ({
          category,
          tags: snapshots.reduce((acc, snap) => {
            acc[snap.id] = { id: snap.id, category, ...snap.data() } as BaseTag;
            return acc;
          }, {} as { [id: string]: BaseTag }),
        })),
        catchError(() => of({ category, tags: {} as { [id: string]: BaseTag } }))
      );
    });

    return forkJoin(requests).pipe(
      map((results) => {
        return results.reduce((acc, item) => {
          acc[item.category] = item.tags;
          return acc;
        }, {} as { [category: string]: { [id: string]: BaseTag } });
      })
    );
  }
}
